// extracted by mini-css-extract-plugin
module.exports = {"PageStyles":"JgVlVCmJUZ0FQeCeA7Piww==","UploadFail":"_7CjY5yeRr3FqbOTb5SOVwg==","Card":"ecBWYx7GqJXS3VHVHNxEfA=="};